/**
 * @var {string[]}
 */
import blacklist from "./blacklist.json" assert {type:"json"};
/**
 * @var {string[]}
 */
import whitelist from "./whitelist.json" assert {type:"json"};

import {getRulesForAccount, getRulesForIntegration} from "./org-rules.js";

const cfg = {};

/**
 * @param {Object} urls                Dict of important URLs, e.g. the "how to use extension" page
 * @param {string} urls.how_to_use_ext Url of onboarding page
 */
const init = (urls: any) => {
	(cfg as any).urls = urls;
};

/**
 * Returns true if the given URL is blacklisted (and not whitelisted),
 * according to local configs and the user's blacklist.
 *
 * The user's blacklist should be an all lowercase text list of host names.
 * Note that the user's blacklist supercedes our internal whitelist.
 *
 * @param {string}   url
 * @param {string[]} userBlacklist
 * @return {boolean}
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'url' implicitly has an 'any' type.
const isBlacklisted = (url, userBlacklist) => {
	// First check user's list, so that it overrides anything in our whitelist.
	const u = new URL(url);
	const host = u.host.toLowerCase();

	const ub = (Array.isArray(userBlacklist)) ? userBlacklist : [];
	for (const domain of ub) {
		if (host === domain)
			return true; // user blacklisted
	}

	// Not blacklisted by user. Now check our lists.

	const regexPrefix = "^(http|https):\/\/((?!\\?).)*";
	for (const bdomain of blacklist) {
		const bre = new RegExp(regexPrefix + bdomain, "i");

		if (bre.test(url)) {
			// Site is blacklisted. Just verify that it hasn't been explicitly whitelisted.
			for (const wdomain of whitelist) {
				const wre = new RegExp(regexPrefix + wdomain, "i");
				if (wre.test(url))
					return false; // whitelisted
			}

			// Make sure we allow the "getting started" page
			if (isOnboardingPage(url))
				return false; // whitelisted

			return true; // blacklisted
		}
	}

	return false; // not whitelisted or blacklisted
};

/**
 * @param {Object} account
 * @param {string} url
 * @param {boolean} toPublicUrl
 * @param {boolean} isRecursiveCall
 * @return {string}
 */
// @ts-expect-error TS(7023) FIXME: 'processOrgProxy' implicitly has return type 'any'... Remove this comment to see the full error message
const processOrgProxy = (account, url, toPublicUrl = false, isRecursiveCall = false) => {
	if (toPublicUrl && !isRecursiveCall)
		url = processOrgProxy(account, url, false);

	const rules = getRulesForAccount(account) || getRulesForIntegration();
	if (!rules)
		return url;

	// @ts-expect-error TS(7006) FIXME: Parameter 'rule' implicitly has an 'any' type.
	for (const transform of rules.filter(rule => rule.toPublicUrl === toPublicUrl)) {
		const match = url.match(transform.regex);
		if (!match)
			continue;

		const {url: newUrl, final} = transform.process(...match);
		return final ? newUrl : processOrgProxy(account, newUrl, toPublicUrl, true);
	}

	// No match found
	return url;
};

/**
 * @param {string} url
 * @return {boolean}
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'url' implicitly has an 'any' type.
const isOnboardingPage = (url) => {
	return (url.indexOf((cfg as any).urls.how_to_use_ext) === 0);
};

export default {
	init,
	isBlacklisted,
	processOrgProxy,
	isOnboardingPage
};
